<template>
  <v-rating
    v-if="hasRating"
    dense
    small
    readonly
    half-increments
    length="10"
    half-icon="mdi-star-half-full"
    :value="rating"
  />
</template>

<script>
export default {
  name: 'FilmRating',
  props: {
    id: Number,
    rating: {
      type: Number,
    },
  },
  computed: {
    hasRating() {
      return this.rating === 0 || (this.rating > 0 && this.rating <= 10)
    },
  },
}
</script>
